<template>
  <div>
    <!-- <experimental-layout v-if="experimentalInterface" />
    <default-layout v-else /> -->

    <!-- Resizable feature (table/filter split) now implemented in default layout -->
    <default-layout />
  </div>
</template>

<script>
import defaultLayout from "./layouts/default";
import experimentalLayout from "./layouts/experimental";

export default {
  components: {
    defaultLayout,
    experimentalLayout
  },
  computed: {
    experimentalInterface() {
      return this.$store.getters["Auth/hasPermission"](
        "experimental interface"
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/index.vue